/* Généré par construire.mjs depuis theme-src/animolife.js : module « accueil », chargé après animolife.js. */
(() => {
  "use strict";
  const { $, $$, H, T, envoyerRadar, icone, lirePopulaire, pluriel, preuve, remplir, stockage } = window.animolife.o;
  /* --- Recherche du catalogue (recherche.py), la part qui tient dans le navigateur : le texte et le prix --- */
  const recherche = (() => {
    const plier = (s) => s.normalize("NFKD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
    const normaliser = (s) => plier(s).replace(/[^\w€<>=.,-]+/g, " ").trim();
    const mots = (s) => normaliser(s).match(/[a-z0-9]+/g) || [];
    const VIDES = new Set(
      "a au aux avec ce ces cet cette d de des du en et l la le les ma mes mon ou par pas pour qu que qui sa ses son sur ta tes ton tres un une an and for in my of on or that the this to very with your al con del el las los mi mis muy o para por su sus una unas uno unos y".split(" "),
    );
    // Une requête réduite à ces mots ne restreint rien : « cadeau à moins de 40 € »
    const GENERIQUES = new Set(
      "article articles cadeau cadeaux chose idee idees objet objets truc gift gifts item items something thing algo articulo articulos idea ideas objeto objetos regalo regalos".split(" "),
    );
    const N = String.raw`(\d+(?:[.,]\d{1,2})?)`;
    const M = String.raw`(?:\s*(?:€|euros?\b|eur\b))?`;
    const A = String.raw`(?:[€$]\s*)?`;
    const PRIX = [
      [new RegExp(String.raw`(?:\b(?:entre|between|de|from|desde)\s+)?${A}${N}${M}\s*(?:\bet\b|\band\b|\ba\b|\by\b|\bto\b|-)\s*${A}${N}${M}`), "entre"],
      [new RegExp(String.raw`${A}${N}${M}\s*(?:max(?:imum)?|maxi|au plus|at most|or less|ou moins|como maximo|maximo)\b`), "max"],
      [new RegExp(String.raw`(?:\bmoins de|\bmax(?:imum)?|\bjusqu ?a|\bpas plus de|\bau plus|\bbudget(?: de| of| max(?:imum)?)?|\bunder|\bbelow|\bless than|\bup to|\bat most|\bmenos de|\bhasta|\bpresupuesto(?: de)?|\b(?:como )?maximo|<=?)\s*${A}${N}${M}`), "max"],
      [new RegExp(String.raw`(?:\bplus de|\bau moins|\ba partir de|\bover|\babove|\bmore than|\bmas de|>=?)\s*${A}${N}${M}`), "min"],
    ];
    const cents = (n) => Math.round(parseFloat(n.replace(",", ".")) * 100);
    const analyser = (q) => {
      let texte = normaliser(q);
      let bas = null;
      let haut = null;
      for (const [motif, sorte] of PRIX) {
        const m = texte.match(motif);
        if (!m) continue;
        if (sorte === "entre") [bas, haut] = [cents(m[1]), cents(m[2])].sort((x, y) => x - y);
        else if (sorte === "max") haut = cents(m[1]);
        else bas = cents(m[1]);
        texte = `${texte.slice(0, m.index)} ${texte.slice(m.index + m[0].length)}`.trim();
        break;
      }
      texte = texte.replace(/(?:[€$]|\beuros?\b|\beur\b)/g, " ");
      // Les mots qui portent la requête : ni mots vides, ni « cadeau » s'il y a mieux
      const utiles = mots(texte).filter((m) => !VIDES.has(m));
      const precis = utiles.filter((m) => !GENERIQUES.has(m));
      return { mots: precis, bas, haut };
    };
    const racine = (m) => {
      for (const fin of ["es", "s", "x"]) if (m.length > 4 && m.endsWith(fin)) return m.slice(0, -fin.length);
      return m;
    };
    // Ressemblance de deux mots, à la manière de SequenceMatcher : 2 × lettres communes / longueurs
    const ressemblance = (a, b) => {
      let precedente = new Array(b.length + 1).fill(0);
      for (let i = 1; i <= a.length; i++) {
        const ligne = [0];
        for (let j = 1; j <= b.length; j++) {
          ligne.push(a[i - 1] === b[j - 1] ? precedente[j - 1] + 1 : Math.max(ligne[j - 1], precedente[j]));
        }
        precedente = ligne;
      }
      return (2 * precedente[b.length]) / (a.length + b.length);
    };
    const proche = (mot, v) => {
      if (mot === v) return true;
      // Un mot en cours de frappe : « kits » ; pas « art » pour « artisanat »
      if (mot.length >= 4 && v.startsWith(mot)) return true;
      if (racine(v) === racine(mot)) return true;
      // Une faute de frappe sur un mot assez long : « kokechi », « hanya »
      if (mot.length < 4 || Math.abs(v.length - mot.length) > 2) return false;
      return ressemblance(mot, v) >= 0.8;
    };
    const vocabulaire = (texte) => [...new Set(mots(texte))];
    const correspond = (requete, vocab, prix) => {
      if (requete.bas !== null && prix < requete.bas) return false;
      if (requete.haut !== null && prix > requete.haut) return false;
      return requete.mots.every((m) => vocab.some((v) => proche(m, v)));
    };
    return { analyser, vocabulaire, correspond };
  })();

  /* --- Sélection de l'accueil : univers, tri, recherche en direct (Home.jsx) --- */
  const selection = $("[data-selection]");
  if (selection) {
    const plateau = $("[data-plateau]", selection);
    const cases = plateau ? $$("[data-case]", plateau) : [];
    const ordre = new Map(cases.map((c, i) => [c, i]));
    // Vocabulaire de chaque case, sans accents : « éventail » se trouve en tapant « eventail »
    const vocabulaires = new Map(cases.map((c) => [c, recherche.vocabulaire(c.dataset.texte)]));
    const segments = $("[data-segments]", selection);
    const tri = $("[data-tri]", selection);
    const champ = $("#recherche");
    const titre = $("[data-titre-selection]", selection);
    const vide = $("[data-vide]", selection);
    const regles = new Intl.PluralRules(H.langue);
    const parametres = new URLSearchParams(location.search);
    // Seuls les univers et familles de la boutique passent : un lien piégé n'écrit pas son texte dans le titre
    const universConnus = new Set($$('[role="radio"]', segments || selection).map((b) => b.dataset.univers));
    const universConnu = (u) => (u && universConnus.has(u) ? u : "");
    const familleConnue = (f) => (f && Object.hasOwn(T.familles || {}, f) ? f : "");
    let univers = universConnu(parametres.get("univers"));
    // Chats ou chiens : un filtre par étiquette, posé par les tuiles de familles ou l'en-tête
    let famille = familleConnue(parametres.get("tag"));
    // Un animal du carnet : son espèce, et son poids quand l'objet déclare une plage
    let animal = null;
    const boutonsAnimaux = $$("[data-pour-animal]", selection);
    const convientA = (c, a) => {
      if (!(c.dataset.familles || "").split(" ").includes(a.espece)) return false;
      const min = parseFloat(c.dataset.poidsMin);
      const max = parseFloat(c.dataset.poidsMax);
      return !(min > a.poids) && !(max < a.poids);
    };
    // Une recherche restée sans réponse part au radar des envies, une fois arrêtée de taper
    let minuteurRadar = 0;

    // Le calque de mouvement, s'il est chargé, fait glisser les cases vers leur nouvelle place
    const recomposer = () => (window.animolifeRecomposer ? window.animolifeRecomposer(appliquer, plateau) : appliquer());
    const appliquer = () => {
      const requete = (champ?.value || "").trim();
      const analyse = recherche.analyser(requete);
      let visibles = 0;
      const tries = [...cases].sort((a, b) => {
        if (tri?.value === "asc") return a.dataset.prix - b.dataset.prix;
        if (tri?.value === "desc") return b.dataset.prix - a.dataset.prix;
        if (tri?.value === "new") return b.dataset.date - a.dataset.date;
        return ordre.get(a) - ordre.get(b);
      });
      for (const c of tries) {
        const ok = (!univers || c.dataset.univers === univers) && (!famille || c.dataset.familles.split(" ").includes(famille)) && (!animal || convientA(c, animal)) && recherche.correspond(analyse, vocabulaires.get(c), Number(c.dataset.prix));
        c.hidden = !ok;
        if (ok) visibles += 1;
        plateau.append(c);
      }
      for (const b of $$('[role="radio"]', segments || selection)) {
        // Un filtre par animal ne coche aucune catégorie : « Tout » reste le point de retour
        const actif = b.dataset.univers === univers && (!famille || b.dataset.univers === "");
        b.setAttribute("aria-checked", String(actif));
        b.tabIndex = actif ? 0 : -1;
      }
      for (const b of boutonsAnimaux) b.setAttribute("aria-pressed", String(animal?.bouton === b));
      if (titre) titre.textContent = (animal && remplir(T.petForName, { nom: animal.nom })) || univers || (famille && T.familles[famille]) || titre.dataset.titreTout;
      clearTimeout(minuteurRadar);
      if (visibles === 0 && requete.length >= 3) minuteurRadar = setTimeout(() => envoyerRadar(requete), 2000);
      const compte = $("[data-compte-selection]", selection);
      if (compte) compte.textContent = remplir(T.objets[regles.select(visibles)] || T.objets.other, { n: visibles });
      if (plateau) plateau.hidden = visibles === 0;
      if (vide) {
        vide.hidden = visibles > 0;
        const p = $("[data-vide-texte]", vide);
        if (p && requete) p.textContent = remplir(p.dataset.texteRequete, { q: champ.value.trim() });
      }
    };

    segments?.addEventListener("click", (e) => {
      const b = e.target.closest('[role="radio"]');
      if (!b) return;
      univers = b.dataset.univers;
      famille = "";
      animal = null;
      recomposer();
    });
    for (const b of boutonsAnimaux) {
      b.addEventListener("click", () => {
        // Un second appui rend tout le plateau
        animal = animal?.bouton === b ? null : { bouton: b, nom: b.dataset.nom, espece: b.dataset.espece, poids: parseFloat(b.dataset.poids) };
        univers = "";
        famille = "";
        recomposer();
      });
    }
    // Les tuiles de familles et les liens de l'en-tête filtrent ici, sans recharger la page
    document.addEventListener("click", (e) => {
      const lien = e.target.closest("[data-famille-lien], .hd-nav a[href*='tag='], .hd-nav a[href*='#selection']");
      if (!lien || e.metaKey || e.ctrlKey || e.shiftKey) return;
      const url = new URL(lien.href, location.href);
      if (url.pathname !== location.pathname) return;
      e.preventDefault();
      univers = universConnu(url.searchParams.get("univers"));
      famille = familleConnue(url.searchParams.get("tag"));
      animal = null;
      history.replaceState(null, "", url.search + "#selection");
      appliquer();
      selection.scrollIntoView({ behavior: "smooth" });
    });
    segments?.addEventListener("keydown", (e) => {
      const boutons = $$('[role="radio"]', segments);
      const i = boutons.findIndex((b) => b.dataset.univers === univers);
      const dernier = boutons.length - 1;
      const suivant = { ArrowRight: i === dernier ? 0 : i + 1, ArrowDown: i === dernier ? 0 : i + 1, ArrowLeft: i === 0 ? dernier : i - 1, ArrowUp: i === 0 ? dernier : i - 1, Home: 0, End: dernier }[e.key];
      if (suivant === undefined) return;
      e.preventDefault();
      univers = boutons[suivant].dataset.univers;
      appliquer();
      boutons[suivant].focus();
    });
    tri?.addEventListener("change", recomposer);
    $("[data-tout-afficher]", selection)?.addEventListener("click", () => {
      univers = "";
      famille = "";
      if (champ) champ.value = "";
      recomposer();
    });
    // Sur l'accueil, la recherche filtre le plateau en direct, comme sur le front d'origine
    champ?.addEventListener("input", () => {
      appliquer();
      if (champ.value.trim() && selection.getBoundingClientRect().top > window.innerHeight) {
        selection.scrollIntoView({ behavior: "smooth" });
      }
    });
    champ?.closest("form")?.addEventListener("submit", (e) => {
      e.preventDefault();
      selection.scrollIntoView({ behavior: "smooth" });
    });
    if (plateau) appliquer();

    // Vus récemment : reconstruits depuis les cases du plateau
    const recents = stockage.lire("recent", []);
    const zone = $("[data-recents]", selection);
    const liste = $("[data-recents-liste]", selection);
    if (zone && liste && recents.length) {
      for (const handle of recents) {
        const c = cases.find((x) => x.dataset.handle === handle);
        if (!c) continue;
        const img = $(".case-art img", c);
        const li = document.createElement("li");
        li.innerHTML = `<a class="recent-item" href="${$(".case-open", c).href}"><span class="recent-art">${img ? `<img class="art art-photo" src="${img.currentSrc || img.src}" alt="" width="56" height="56" loading="lazy">` : ""}</span><span class="recent-name"></span><span class="price"></span></a>`;
        $(".recent-name", li).textContent = $(".case-open", c).textContent;
        $(".price", li).textContent = $(".case-foot .price", c).textContent;
        liste.append(li);
      }
      zone.hidden = liste.children.length === 0;
    }
  }

  // Téléphone : la loupe de l'en-tête déplie la recherche, Échap la replie
  const entete = $(".hd");
  const loupe = $("[data-ouvre-recherche]");
  if (entete && loupe) {
    const zone = $("[data-recherche]", entete);
    const regler = (ouverte) => {
      entete.toggleAttribute("data-recherche-ouverte", ouverte);
      loupe.setAttribute("aria-expanded", String(ouverte));
    };
    loupe.addEventListener("click", () => {
      const ouvre = !entete.hasAttribute("data-recherche-ouverte");
      regler(ouvre);
      if (ouvre) $("input[type=search]", zone)?.focus();
    });
    zone.addEventListener("keydown", (e) => {
      if (e.key !== "Escape") return;
      regler(false);
      loupe.focus();
    });
  }

  // Raccourci « / » : la recherche, sauf pendant une saisie
  document.addEventListener("keydown", (e) => {
    const cible = e.target;
    const enSaisie = cible instanceof HTMLElement && (cible.isContentEditable || ["INPUT", "TEXTAREA", "SELECT"].includes(cible.tagName));
    if (e.key === "/" && !enSaisie && !e.metaKey && !e.ctrlKey && !e.altKey) {
      e.preventDefault();
      $("#recherche")?.focus();
    }
  });

  // La reliure : sur l'accueil filtré, l'onglet Chats ou Chiens s'ouvre à la place de la boutique
  const tagOuvert = new URLSearchParams(location.search).get("tag");
  const ongletTag = tagOuvert && $(`[data-onglet-tag="${CSS.escape(tagOuvert)}"]`);
  if (ongletTag) {
    $("[data-onglet-boutique]")?.removeAttribute("aria-current");
    ongletTag.setAttribute("aria-current", "page");
  }

  // Langue : la liste envoie son formulaire dès qu'on choisit

  // Code de bienvenue : un clic le copie
  document.addEventListener("click", async (e) => {
    const bouton = e.target.closest("[data-copie]");
    if (!bouton) return;
    try {
      await navigator.clipboard.writeText(bouton.dataset.copie);
      bouton.lastElementChild.outerHTML = icone("check", 16);
    } catch {
      /* le code reste lisible et sélectionnable */
    }
  });

  /* --- Objets mis en avant (accueil-ventes.liquid) : choisis à la main, ou les plus commandés ; « Commandé N fois » toujours compté pour de vrai --- */
  const sectionsVentes = $$("[data-ventes-section]");
  if (sectionsVentes.length) {
    const ecrireCompte = (li, n) => {
      $("[data-vente-compte]", li).textContent = remplir(T.ventesN[pluriel.select(n)] || T.ventesN.other, { n });
    };
    lirePopulaire()
      .then((p) => {
        const compte = p?.ventes || {};
        for (const ventes of sectionsVentes) {
          const rail = $(".ventes-rail", ventes);
          const afficher = ventes.hasAttribute("data-compte");
          if (ventes.hasAttribute("data-a-la-main")) {
            // L'ordre et le choix sont ceux de la boutique : seuls les vrais chiffres s'ajoutent, si elle le veut
            if (afficher) for (const li of $$("[data-vente]", rail)) if (compte[li.dataset.vente] > 0) ecrireCompte(li, compte[li.dataset.vente]);
            continue;
          }
          const tries = Object.entries(compte)
            .filter(([handle, n]) => n > 0 && $(`[data-vente="${CSS.escape(handle)}"]`, rail))
            .sort((a, b) => b[1] - a[1])
            .slice(0, Number(ventes.dataset.nombre) || 8);
          if (!tries.length) continue;
          for (const [handle, n] of tries) {
            const li = $(`[data-vente="${CSS.escape(handle)}"]`, rail);
            if (afficher) ecrireCompte(li, n);
            li.hidden = false;
            rail.append(li);
          }
          const chapeau = $("[data-ventes-chapeau]", ventes);
          if (chapeau) chapeau.textContent = chapeau.dataset.modele.replace("__j__", p.jours);
          ventes.hidden = false;
        }
      })
      .catch(() => {
        /* serveur endormi : un choix à la main reste affiché, les plus commandés restent cachés */
      });
  }

  /* --- Histoires de clients (accueil-histoires.liquid) : une vidéo au toucher, avec le son, une seule à la fois --- */
  for (const bloc of $$("[data-histoire]")) {
    const video = $("video", bloc);
    const jouer = $("[data-histoire-jouer]", bloc);
    if (!video || !jouer) continue;
    jouer.addEventListener("click", () => {
      for (const autre of $$("[data-histoire] video")) if (autre !== video) autre.pause();
      video.controls = true;
      video.play().catch(() => {});
    });
    video.addEventListener("play", () => (jouer.hidden = true));
    video.addEventListener("ended", () => {
      video.controls = false;
      jouer.hidden = false;
    });
  }

  /* --- Conseil cadeau : une conversation, servie par le serveur des agents --- */
  const conseil = $("[data-conseil]");
  if (conseil && H.apiConseil) {
    const api = H.apiConseil.replace(/\/$/, "");
    fetch(`${api}/conseil/etat`)
      .then((r) => (r.ok ? r.json() : null))
      .then((etat) => {
        if (etat?.actif) conseil.hidden = false;
      })
      .catch(() => {
        /* serveur injoignable ou adresse de la boutique non autorisée : la section reste absente */
      });

    const form = $("[data-conseil-form]", conseil);
    const champ = $("#conseil-champ", conseil);
    const erreurChamp = $("#conseil-erreur", conseil);
    const fil = $("[data-conseil-fil]", conseil);
    const textes = fil.dataset;
    const bouton = $('button[type="submit"]', form);
    const calme = window.matchMedia?.("(prefers-reduced-motion: reduce)");
    // Par l'adresse de l'objet : un SKU de fournisseur n'a pas de code HNB à afficher
    const cases = new Map($$("[data-case]").map((c) => [c.dataset.handle, c]));

    const choix = ({ produit, raison }) => {
      const c = cases.get(produit.handle);
      if (!c) return null;
      const lien = $(".case-open", c);
      const img = $(".case-art img", c);
      const ajout = $("[data-ajout]", c);
      const li = document.createElement("li");
      li.className = "conseil-objet";
      li.innerHTML = `
        <span class="conseil-art">${img ? `<img class="art art-photo" src="${img.currentSrc || img.src}" alt="" loading="lazy">` : ""}</span>
        <div class="conseil-texte"><h3><a class="conseil-nom link-plain" href="${lien.href}"></a></h3><p></p></div>
        <div class="conseil-pied"><span class="price"></span></div>`;
      $(".conseil-nom", li).textContent = lien.textContent.trim();
      $(".conseil-texte p", li).textContent = raison;
      $(".price", li).textContent = $(".case-foot .price", c).textContent.trim();
      const bout = ajout ? ajout.cloneNode(true) : $(".case-add", c).cloneNode(true);
      $(".conseil-pied", li).append(bout);
      return li;
    };

    // Une bulle de la conversation, nommée pour les lecteurs d'écran
    const bulle = (qui) => {
      const li = document.createElement("li");
      li.className = `conseil-bulle conseil-${qui}`;
      const nom = document.createElement("span");
      nom.className = "sr-only";
      // L'espace avant les deux-points est une règle du français seulement
      nom.textContent = `${qui === "moi" ? textes.texteMoi : textes.texteLui}${H.langue.startsWith("fr") ? " :" : ":"} `;
      li.append(nom);
      return li;
    };
    const paragraphe = (texte, classe = "conseil-message") => {
      const p = document.createElement("p");
      p.className = classe;
      p.textContent = texte;
      return p;
    };
    const montrer = (el) => el.scrollIntoView({ block: "start", behavior: calme?.matches ? "auto" : "smooth" });

    const envoyer = async (demande) => {
      if (demande.length < 3) {
        erreurChamp.hidden = false;
        champ.setAttribute("aria-invalid", "true");
        champ.setAttribute("aria-describedby", "conseil-erreur conseil-confidentialite");
        champ.focus();
        return;
      }
      erreurChamp.hidden = true;
      champ.removeAttribute("aria-invalid");
      champ.value = "";
      const moi = bulle("moi");
      moi.append(demande);
      const lui = bulle("lui");
      lui.setAttribute("aria-busy", "true");
      lui.append(paragraphe(textes.texteAttente, "conseil-attend"));
      fil.append(moi, lui);
      fil.hidden = false;
      // Les trois derniers échanges suffisent
      while (fil.children.length > 6) fil.firstElementChild.remove();
      // Le clavier se range, la réponse attendue entre dans l'écran
      champ.blur();
      montrer(moi);
      bouton.disabled = true;
      try {
        const antibot = await preuve(api, "conseil", $(".honeypot", form));
        const r = await fetch(`${api}/conseil`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ demande, lang: ["fr", "en", "es", "de", "it", "nl", "pt"].includes(H.langue.slice(0, 2)) ? H.langue.slice(0, 2) : "fr", antibot }),
        });
        if (!r.ok) throw Object.assign(new Error("conseil"), { status: r.status });
        const resultat = await r.json();
        $(".conseil-attend", lui).remove();
        if (resultat.vide === "budget") {
          lui.append(paragraphe(textes.texteBudget));
          return;
        }
        const objets = (resultat.choix || []).map(choix).filter(Boolean);
        const message = resultat.message || (objets.length ? "" : textes.texteAucun);
        if (message) lui.append(paragraphe(message));
        if (objets.length) {
          const ol = document.createElement("ol");
          ol.className = "conseil-choix";
          ol.setAttribute("aria-label", textes.texteResultats);
          ol.append(...objets);
          lui.append(ol);
        }
      } catch (err) {
        $(".conseil-attend", lui)?.remove();
        const texte = err.status === 429 ? textes.texteLimite : err.status === 400 ? textes.texteAntibot : textes.texteErreur;
        const alerte = paragraphe(texte, "conseil-message conseil-erreur");
        alerte.setAttribute("role", "alert");
        lui.append(alerte);
      } finally {
        bouton.disabled = false;
        lui.removeAttribute("aria-busy");
        montrer(moi);
      }
    };

    form.addEventListener("submit", (e) => {
      e.preventDefault();
      envoyer(champ.value.trim());
    });
    // Entrée envoie, Maj + Entrée passe à la ligne
    champ.addEventListener("keydown", (e) => {
      if (e.key === "Enter" && !e.shiftKey && !e.isComposing) {
        e.preventDefault();
        form.requestSubmit();
      }
    });
    // Un exemple s'envoie tel quel
    for (const b of $$("[data-exemple]", conseil)) {
      b.addEventListener("click", () => envoyer(b.dataset.demande || b.textContent.trim()));
    }
  }

})();
